import { render, staticRenderFns } from "./arviointilomake-loppukeskustelu.vue?vue&type=template&id=285b4fc9&scoped=true&"
import script from "./arviointilomake-loppukeskustelu.vue?vue&type=script&lang=ts&"
export * from "./arviointilomake-loppukeskustelu.vue?vue&type=script&lang=ts&"
import style0 from "./arviointilomake-loppukeskustelu.vue?vue&type=style&index=0&id=285b4fc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285b4fc9",
  null
  
)

export default component.exports